import { FaPhone } from "react-icons/fa";
import { AlertContainer, ButtonContainer, Container, Content, Header, Main, ErrorMessage, InputContainer } from "./style";
import InputText from "../../components/ui/inputText";
import { useTranslator } from "../../context/TranslatorContext";
import { Button } from "../../components/Button";
import { useForm, Controller } from "react-hook-form";
import * as z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import InputMask from "react-input-mask";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../services/api";
import { toast } from "react-toastify";

export default function RequestPhoneModal() {
	const { getText } = useTranslator();
	const { token } = useAuth();
	const [userInfo, setUserInfo] = useState(null)
	const [isLoading, setIsLoading] = useState(false);

	const schema = z.object({
		phone: z
			.string({ required_error: "Telefone é obrigatório" })
			.min(1, "Telefone é obrigatório")
			.refine((value) => {
				const numbersOnly = value.replace(/\D/g, '');
				return numbersOnly.length === 11;
			}, "Telefone deve ter 11 dígitos (DDD + número)")
	});

	const { control, handleSubmit, formState: { errors }, setValue } = useForm({
		resolver: zodResolver(schema),
		defaultValues: {
			phone: ""
		}
	});

	const formatPhone = useCallback((phone) => {
		if (!phone) return "";

		const numbersOnly = phone.replace(/\D/g, '');

		if (numbersOnly.length === 11) {
			return `(${numbersOnly.slice(0, 2)}) ${numbersOnly.slice(2, 7)}-${numbersOnly.slice(7)}`;
		}

		if (numbersOnly.length === 10) {
			return `(${numbersOnly.slice(0, 2)}) ${numbersOnly.slice(2, 6)}-${numbersOnly.slice(6)}`;
		}
		return phone;
	}, []);

	useEffect(() => {
		try {
			const fetchUserPhone = async () => {
				const response = await api.get("/v1/person/shopping", {
					headers: {
						token
					}
				});

				const formattedPhone = formatPhone(response.data.body.userInfo.telefone);
				setValue("phone", formattedPhone);
				setUserInfo(response.data.body.userInfo)
			};

			fetchUserPhone();
		} catch { }
	}, [token, setValue, formatPhone]);

	const onSubmit = async (data) => {
		try {
			setIsLoading(true);

			const phoneNumbersOnly = data.phone.replace(/\D/g, '');

			const response = await api.put("/v1/person/phone", {
				telefone: phoneNumbersOnly
			}, {
				headers: {
					token
				}
			});

			toast.success(response.data.message);
			setUserInfo(null);
		} catch (error) {
			toast.error(error?.response?.data?.message || "Erro ao atualizar o telefone, tente novamente.");
		} finally {
			setIsLoading(false);
		}
	};

	const handleLater = () => {
		setUserInfo(null)
	};

	return (
		<>
			{
				userInfo?.shoppingVerifyPhone && (
					<Container>
						<Content>
							<Header>
								<FaPhone size={48} />
								<h3>{getText("shopping.confirm-phone-header")}</h3>
								<span>{getText("shopping.confirm-phone-message")}</span>
							</Header>
							<Main>
								<form onSubmit={handleSubmit(onSubmit)}>
									<Controller
										control={control}
										name="phone"
										render={({ field: { onChange, value } }) => (
											<InputContainer>
												<InputMask
													mask="(99) 99999-9999"
													value={value || ""}
													onChange={(event) => {
														onChange(event.target.value);
													}}
												>
													{(inputProps) => (
														<InputText
															{...inputProps}
															label={getText("shopping.phone")}
															placeholder="(99) 99999-9999"
															type="tel"
															id="phone"
															removeMargin
														/>
													)}
												</InputMask>
												{errors?.phone && (
													<ErrorMessage>{errors.phone.message}</ErrorMessage>
												)}
											</InputContainer>
										)}
									/>
									<AlertContainer>
										<span>{getText("shopping.confirm-phone-warn")}</span>
									</AlertContainer>
									<ButtonContainer>
										<Button type="button" onClick={handleLater} disabled={isLoading}>
											{getText("shopping.confirm-phone-later")}
										</Button>
										<Button type="submit" disabled={isLoading}>
											{getText("shopping.confirm-phone-button")}
										</Button>
									</ButtonContainer>
								</form>
							</Main>
						</Content>
					</Container>
				)
			}
		</>
	)
}
